import FollowData from "../../components/followdata";
import Header from "../../components/header";
import IconBack from "../../componentsStyled/icon/Iconback";
import { useNavigate, useLocation } from "react-router-dom";
import ChatFlutuant from "../../components/ChatFlutuant";
import MenuLateral from "../../components/MenuLateral";
import StatusDevolution from "../../components/statusdevolution";
import DetailsDevolution from "../../components/detailsdevolution";
import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import apiConnect from "../../api/apiConnect";
import HeaderMobile from "../../components/headerMobile";
import LoadingBox from "../../components/LoadingBox";

type auth = {
  basicAuth: string;
  code: number;
  email: string;
  customerId: string;
  token: string;
};

type devolutionData = {
  id: number;
  status_id: number;
  order_id: number;
  method_shipment: string;
  dateCreatedReturn: string;
  customer: {
    fullname: string;
    fone: string;
    cellphone: string;
    cep: string;
    state: string;
    city: string;
    neigh_borhood: string;
    street: string;
    number: string;
    complement: string;
  };
  products: Array<{
    name: string;
    image: string;
    quant: number;
    price: string;
    refundType: string;
    reasonSub: string;
    reasonMain: string;
    obs: string;
    variant: string;
    url_pdf: any;
  }>;
  history: Array<{
    title: string;
    date: string;
    fileIcon: string;
    status: string;
  }>;
  status: {
    title: string;
    status: string;
    msg: string;
    color: string;
  };
  coupon: any;
  ldn: {
    status: boolean;
    url: string;
  };
};

export default function Follow() {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/devolution");
  };
  const { state } = useLocation();
  const devolutionId = state?.devolutionId;

  const [devolutionData, setDevolutionData] = useState<devolutionData>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleGetDevolution = () => {
    let auth = localStorage.getItem("auth");
    const authObj: auth = JSON.parse(auth);
    setLoading(true);
    apiConnect.apiAPP
      .get(`/accompany/${authObj.customerId}/${devolutionId}`)
      .then((resp) => {
        if (resp.data[0] != "Solicitação não encontrada!") {
          setDevolutionData(resp.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error get DevolutionData:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetDevolution();
  }, [devolutionId]);

  return (
    <>
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <Header />
        <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={5}>
          <MenuLateral currentPage="devolution" />
          <Box width={"100%"} ml={2}>
            <Box display={"flex"} alignItems={"center"}>
              <Button onClick={handleBack}>
                <IconBack width={20} />
              </Button>
              <p style={{ fontSize: 20, fontWeight: 500 }}>Solicitação #{devolutionId}</p>
            </Box>
            {loading ? (
              <LoadingBox loadType="static" />
            ) : devolutionData != null ? (
              <Box>
                <StatusDevolution devolutionData={devolutionData} />

                <Box display={"flex"} alignItems={"center"} mt={5}>
                  <DetailsDevolution devolutionData={devolutionData} />
                  <FollowData devolutionData={devolutionData} />
                </Box>
              </Box>
            ) : (
              <Box>
                <p>Sem produtos Index</p>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      {/* desktop */}

      {/* Mobile */}
      <Box display={{ xs: "initial", md: "none" }}>
        <HeaderMobile currentPage="devolution" />
        <Box>
          <Button onClick={handleBack} startIcon={<IconBack width={20} />} style={{ color: "#000", fontSize: 18, fontWeight: 400 }}>
            Solicitação #{devolutionId}
          </Button>
          {loading ? (
            <LoadingBox loadType="static" />
          ) : devolutionData != null ? (
            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={2}>
              <StatusDevolution devolutionData={devolutionData} />

              <DetailsDevolution devolutionData={devolutionData} />
              <FollowData devolutionData={devolutionData} />
            </Box>
          ) : (
            <Box>
              <p>Sem produtos para exibir</p>
            </Box>
          )}
        </Box>
      </Box>
      {/* Mobile */}

      <ChatFlutuant />
      <div style={{ marginBottom: 100 }} />
    </>
  );
}
